import { render, staticRenderFns } from "./LaboratoryFilter.vue?vue&type=template&id=8762066e"
import script from "./LaboratoryFilter.vue?vue&type=script&lang=js"
export * from "./LaboratoryFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports